import React from 'react';
import { DatePick, Field, Select } from "./..";
import { Search as SearchIcon } from "../../../icons";
var prependMap = {
  search: /*#__PURE__*/React.createElement(SearchIcon, {
    color: "N300"
  })
};
export var Filters = function Filters(_ref) {
  var filterList = _ref.filterList;

  // eslint-disable-next-line consistent-return
  var defineFilter = function defineFilter(filter) {
    // eslint-disable-next-line default-case
    switch (filter.type) {
      case 'search':
        return /*#__PURE__*/React.createElement(Field, {
          value: filter.value,
          placeholder: filter.name,
          prepend: prependMap.search,
          onChange: filter.onChange
        });

      case 'select':
        return /*#__PURE__*/React.createElement(Select, {
          name: filter.name,
          value: filter.value,
          onChange: filter.onChange,
          options: filter.options,
          isSearchSelect: filter.isSearchSelect
        });

      case 'date':
        return /*#__PURE__*/React.createElement(DatePick, {
          name: filter.name,
          value: filter.value,
          onChange: filter.onChange,
          withRange: filter.withRange
        });
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, filterList.map(function (filter) {
    return /*#__PURE__*/React.createElement("div", {
      key: filter.name
    }, defineFilter(filter));
  }));
};